export default "__VITE_ASSET__CFc7562j__"